import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import Alert from '../../../1stlog-ui/src/components/Alert'
import LoaderOverlay from '../../../1stlog-ui/src/components/LoaderOverlay'
import Node from './Node'
import Search from './Search'
import useTariffs, { TarrifsContextProvider } from './useTariffs'
import { parseTree } from './utils'
import { requestRoots, requestSearch } from './requests'
import { validateSearch } from './Search/validate'

const Wrapper = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
`

const TreeWrapper = styled.div`
  flex: 1 1 auto;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`

const Tariffs = (props) => {
  const { id, onSelect, initialSearch, isFollowup, country, mode: propMode } = props

  const [isLoading, setIsLoading] = useState(false)

  const { tree, setTree, mergeTree } = useTariffs(id)

  const [search, setSearch] = useState(validateSearch(initialSearch) ? '' : initialSearch)

  const mode = useMemo(() => propMode || (country === 'CH' ? 'tares' : 'taric'), [
    country,
    propMode
  ])

  const loadRoot = async (path = '') => {
    try {
      setIsLoading(true)
      const data = await requestRoots({ mode })
      let initialTree = {}
      lodash.forEach(data, (d) => {
        const parsedTree = parseTree(d)
        // console.log("parsedTree", parsedTree)
        initialTree = { ...initialTree, ...parseTree(d) }
      })
      setTree(initialTree)
    } catch (err) {
      console.error('Failed to load initial tariff tree', err)
    } finally {
      setIsLoading(false)
    }
  }

  const loadSearch = async (query) => {
    try {
      setIsLoading(true)
      const data = await requestSearch({ mode, query })

      let resultTree = {}
      lodash.forEach(data, (d) => {
        const parsedTree = parseTree(d)
        resultTree = { ...resultTree, ...parsedTree }
      })

      // console.log("DATA for subtree", { data, resultTree })
      setTree(resultTree)
    } catch (err) {
      console.error('Failed to load search tariff tree', err)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (lodash.isEmpty(search)) {
      loadRoot()
    } else {
      loadSearch(search)
    }
  }, [search, mode])

  // console.log("tree", tree)

  return (
    <Wrapper>
      <LoaderOverlay isLoading={isLoading} />
      <div className="mb-2">
        <Search search={search} setSearch={setSearch} />
      </div>

      <TarrifsContextProvider value={{ id, mode }}>
        {isFollowup && (
          <Alert info>Bitte detaillieren Sie Ihre Eingaben für die Einfuhr nach {country}</Alert>
        )}
        <TreeWrapper key={search}>
          {/* <VirtualizedTree /> */}
          {!isLoading &&
            lodash.map(tree, (node, path) => (
              <Node
                key={path}
                path={path}
                node={node}
                level={0}
                onSelect={onSelect}
                initiallyExpanded={!!search}
                search={search}
                country={country}
                mode={mode}
              />
            ))}
        </TreeWrapper>
      </TarrifsContextProvider>
    </Wrapper>
  )
}

export default Tariffs
